import React from "react";
import Chart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";
import { ChatScoreCards } from "./chatAnalyticsService";
import { SOURCE_COLORS } from "./chatAnalyticsPalette";

interface ChatSourceDonutProps {
  data: ChatScoreCards | null;
}

const ChatSourceDonut: React.FC<ChatSourceDonutProps> = ({ data }) => {
  if (!data || !data.total_messages || data.total_messages.external === 0) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ height: "320px" }}>
        <div className="text-center">
          <i className="ti ti-message-off fs-1 text-muted mb-3" />
          <p className="text-muted mb-0">No external messages in this selection yet</p>
        </div>
      </div>
    );
  }

  const evalData = data.external_chat_message_evaluation;
  
  const labels = ["Agent replies", "Bot replies", "Sent by customers"];
  const series = [evalData.total_agent_replies, evalData.total_bot_replies, evalData.total_customer_messages];
  const colors = [SOURCE_COLORS.agent, SOURCE_COLORS.bot, SOURCE_COLORS.customer];

  const options: ApexOptions = {
    chart: { type: "donut", height: 320, animations: { enabled: false } },
    labels,
    colors,
    fill: {
      type: "gradient",
      gradient: { shade: "light", type: "diagonal1", shadeIntensity: 0.3, opacityFrom: 1, opacityTo: 0.85 },
    },
    dataLabels: {
      enabled: true,
      style: { fontWeight: 700 },
      formatter: (val: number) => `${val.toFixed(0)}%`,
    },
    legend: { position: "bottom", fontWeight: 600, markers: { size: 7 } },
    stroke: { width: 3, colors: ["#fdfcff"] },
    plotOptions: {
      pie: {
        donut: {
          size: "66%",
          labels: {
            show: true,
            value: { fontSize: "26px", fontWeight: 700 },
            total: {
              show: true,
              label: "External Msgs",
              fontSize: "13px",
              formatter: () => String(data.total_messages.external),
            },
          },
        },
      },
    },
    tooltip: { y: { formatter: (val: number) => `${val} messages` } },
  };

  return <Chart options={options} series={series} type="donut" height={320} />;
};

export default ChatSourceDonut;
